export default class SystemRegistry {
    static instance;

    static getInstance(){
        if(!this.instance){
            this.instance = new SystemRegistry()
        }
        return this.instance
    }

    static gI(){
       return this.getInstance()
    }

    registerToastContainer(container){
        this.toastContainer = container
    }

    registerConsole(container){
        this.console = container
    }

}